import React from "react";
import { ShieldCheck } from "lucide-react";
import { useI18n } from "../lib/i18n";

const inputCls = "mt-2 bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] focus:border-[#D4AF37] rounded-sm px-4 py-2.5 w-full outline-none";
const labelCls = "text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]";

function PhotoInput({ id, label, hint, file, onChange }) {
  const preview = file ? URL.createObjectURL(file) : null;
  return (
    <div>
      <label className={labelCls}>{label}</label>
      <p className="text-xs text-[#A8A8AD] mt-1">{hint}</p>
      <input data-testid={`register-${id}-input`} type="file" required accept="image/jpeg,image/png,image/webp"
        onChange={(e) => onChange(e.target.files[0] || null)} className="mt-2 text-xs text-[#A8A8AD] w-full" />
      {preview && <img data-testid={`register-${id}-preview`} src={preview} alt={label} className="mt-2 max-h-40 rounded-sm border border-[#35353B]" />}
    </div>
  );
}

export function SupplierKycFields({ kyc, setKyc }) {
  const { t } = useI18n();
  const set = (k) => (v) => setKyc({ ...kyc, [k]: v });
  return (
    <div data-testid="register-kyc-section" className="space-y-4 border-t border-[#35353B] pt-4">
      <div className="flex items-start gap-2 text-xs text-[#A8A8AD]">
        <ShieldCheck size={16} className="text-[#D4AF37] shrink-0" />
        <span>{t("kyc.notice")}</span>
      </div>
      <p data-testid="register-contact-hint" className="text-xs text-[#F2D98D]">{t("kyc.contact_hint")}</p>
      <div>
        <label className={labelCls}>{t("kyc.telegram")}</label>
        <input data-testid="register-telegram-input" placeholder="@username" value={kyc.telegram}
          onChange={(e) => set("telegram")(e.target.value)} className={inputCls} />
      </div>
      <div>
        <label className={labelCls}>{t("kyc.whatsapp")}</label>
        <input data-testid="register-whatsapp-input" inputMode="tel" placeholder="6281234567890" value={kyc.whatsapp}
          onChange={(e) => set("whatsapp")(e.target.value)} className={inputCls} />
      </div>
      <PhotoInput id="ktp" label={t("kyc.ktp")} hint={t("kyc.ktp_hint")} file={kyc.ktp} onChange={set("ktp")} />
      <PhotoInput id="selfie" label={t("kyc.selfie")} hint={t("kyc.selfie_hint")} file={kyc.selfie} onChange={set("selfie")} />
    </div>
  );
}

export function KycPendingNotice() {
  const { t } = useI18n();
  return (
    <div data-testid="register-kyc-pending" className="bg-[#202127] border border-[#D4AF37] rounded-lg p-6 space-y-3">
      <ShieldCheck className="text-[#D4AF37]" size={28} />
      <h2 className="text-xl font-bold text-[#F5F3ED]" style={{ fontFamily: "'Playfair Display', serif" }}>{t("kyc.sent_title")}</h2>
      <p className="text-sm text-[#A8A8AD]">{t("kyc.sent_body")}</p>
    </div>
  );
}
